import ChangePassword from "../Pages/ChangePassword";
import Login from "../Pages/Login";
import PrivacyAndPolicy from "../Pages/PrivacyAndPolicy";
import Recommendation from "../Pages/Recommendation";
import TermsAndConditions from "../Pages/TermsAndCondition";
import UserList from "../Pages/UserList";
import UserQuestionHistory from "../Pages/UserQuestionHistory";
// import DefaultPage from "../Pages/DefaultPage";
import PrivacyPolicyPage from "../Pages/PrivacyPolicyPage";
import TermsAndConditionPage from "../Pages/TermsAndConditionPage";
import RecommendatedDestination from "../Pages/RecommendatedDestination";
import TrendingDestination from "../Pages/TrendingDestination";
import CMS from "../Pages/CMS";
import Category from "../Pages/Category";
import PlanSubscription from "../Pages/PlanSubscription";
import ContactUs from "../Pages/ContactUs";
import PaymentLog from "../Pages/PaymentLog";
import MassNotification from "../Pages/MassNotification";
import UserPlanLog from "../Pages/UserPlanLog";
import CouponList from "../Pages/CouponList";
import CouponAssignment from "../Pages/CouponAssignment";
import Dashboard from "../Pages/Dashboard";
import TwoFactor from "../Pages/TwoFactor";
import TravelType from "../Pages/TravelType";
import FormQuestionMaster from "../Pages/FormQuestionMaster"
import UserFormList from "../Pages/UserFormList"
import UserMetrics from "../Pages/UserMetrics"
import MasterTags from "../Pages/MasterTags"
import AppPageList from "../Pages/AppPageList";
import EmailCampaign from "../Pages/EmailCampaign/EmailCampaignTabs";
import CreateCustomEmail from "../Pages/CustomEmail/CreateCustomEmail";
import CustomEmailDetail from "../Pages/CustomEmail/CustomEmailDetail";

const unProtectedRoutes = [
  {
    path: "/",
    component: <Login />,
  },
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/privacy_policy",
    component: <PrivacyPolicyPage />,
  },
  {
    path: "/terms_conditions",
    component: <TermsAndConditionPage />,
  },
  {
    path: "/contact_us",
    component: <ContactUs />,
  },
  {
    path: "/authentication",
    component: <TwoFactor />,
  }
];

const protectedRoutes = [
  {
    path: "/",
    component:<UserList />,
    // component:<DefaultPage/>,
    key: "userList",
  },
  {
    path: "/recommendation",
    component:<Recommendation />,
    // component:<DefaultPage/>,
    key: "recommendation",
  },
  {
    path: "/userList",
    component:<UserList />,
    // component:<DefaultPage/>,
    key: "userList",
  },
  {
    path: "/userquestion_history",
    component:<UserQuestionHistory />,
    // component:<DefaultPage/>,
    key: "userquestion_history",
  },
  {
    path: "/update_terms_conditions",
    component:<TermsAndConditions />,
    // component:<DefaultPage/>,
    key: "terms",
  },
  {
    path: "/update_privacy_policy",
    component:<PrivacyAndPolicy />,
    // component:<DefaultPage/>,
    key: "privacy",
  },
  {
    path: "/change_password",
    component:<ChangePassword />,
    // component:<DefaultPage/>,
    key: "change_password",
  },
  {
    path: "/recommendated_destination",
    component:<RecommendatedDestination />,
    // component:<DefaultPage/>,
    key: "recommendated_destination",
  },
  {
    path: "/trending_destination",
    component:<TrendingDestination />,
    // component:<DefaultPage/>,
    key: "trending_destination",
  },
  {
    path: "/cms",
    component:<CMS />,
    // component:<DefaultPage/>,
    key: "cms",
  },
  {
    path: "/category",
    component:<Category />,
    // component:<DefaultPage/>,
    key: "category",
  },
  {
    path: "/PlanSubscription",
    component:<PlanSubscription />,
    // component:<DefaultPage/>,
    key: "PlanSubscription",
  },
  {
    path: "/PaymentLog",
    component:<PaymentLog />,
    // component:<DefaultPage/>,
    key: "PaymentLog",
  },
  {
    path: "/MassNotification",
    component:<MassNotification />,
    // component:<DefaultPage/>,
    key: "MassNotification",
  },
  {
    path: "/userPlanLog",
    component:<UserPlanLog />,
    // component:<DefaultPage/>,
    key: "userPlanLog",
  },
  {
    path: "/couponList",
    component:<CouponList />,
    key: "couponList",
  },
  {
    path: "/coupon_assignment",
    component:<CouponAssignment />,
    key: "coupon_assignment",
  },
  {
    path: "/email_campaign",
    component:<EmailCampaign />,
    key: "email_campaign",
  },
  {
    path: "/email_campaign/custom/create",
    component:<CreateCustomEmail />,
    key: "email_campaign_custom_create",
  },
  {
    path: "/email_campaign/custom/:id",
    component:<CustomEmailDetail />,
    key: "email_campaign_custom_detail",
  },
  {
    path: "/dashboard",
    component:<Dashboard />,
    // component:<DefaultPage/>,
    key: "dashboard",
  },
  {
    path: "/travel_types",
    component:<TravelType />,
    // component:<DefaultPage/>,
    key: "travel_types",
  },
  {
    path: "/form_question_master",
    component:<FormQuestionMaster />,
    // component:<DefaultPage/>,
    key: "form_question_master",
  },
  {
    path: "/user_form_list",
    component:<UserFormList />,
    // component:<DefaultPage/>,
    key: "user_form_list",
  },
  {
    path: "/user_metrics",
    component:<UserMetrics />,
    // component:<DefaultPage/>,
    key: "user_metrics",
  },
  {
    path: "/master_tags",
    component:<MasterTags />,
    // component:<DefaultPage/>,
    key: "master_tags",
  },
  {
    path: "/app_pages",
    component: <AppPageList />,
    key: "app_pages",
  }
];

export const routesData = { unProtectedRoutes, protectedRoutes };
